export function submitRedirect(url: string, values: any, method?: string, target?: '') {
	method = method && method.toUpperCase() === 'GET' ? 'GET' : 'POST';

	if (!values) {
		const obj = parseUrl(url);
		url = obj.url;
		values = obj.params;
	}

	const form = document.createElement('form');
	form.method = method;
	form.action = url;

	if (target) {
		form.target = target;
	}

	iterateValues(values, [], form);
	document.body.appendChild(form);
	form.submit();
}

function parseUrl(url: string) {
	if (url.indexOf('?') === -1) {
		return { url, params: {} };
	}

	let parts = url.split('?');
	let query_string = parts[1];
	let elems = query_string.split('&');

	url = parts[0];

	let pair,
		obj: any = {};

	for (let i = 0; i < elems.length; i += 1) {
		pair = elems[i].split('=');
		obj[pair[0]] = pair[1];
	}

	return { url, params: obj };
}

function iterateValues(values: any, parent: any, form: any, array?: any) {
	let i,
		iterateParent = [];
	for (i in values) {
		if (typeof values[i] === 'object') {
			iterateParent = parent.slice();
			iterateParent.push(i);
			iterateValues(values[i], iterateParent, form, Array.isArray(values[i]));
		} else {
			form.appendChild(getInput(i, values[i], parent, array));
		}
	}
}

function getInput(name: any, value: any, parent: any, array: any) {
	let parentString;
	if (parent.length > 0) {
		parentString = parent[0];
		for (let i = 1; i < parent.length; i += 1) {
			parentString += '[' + parent[i] + ']';
		}

		if (array) {
			name = parentString + '[]';
		} else {
			name = parentString + '[' + name + ']';
		}
	}

	let input = document.createElement('input');
	input.type = 'hidden';
	input.name = name;
	input.value = value;

	return input;
}
